export const getGridTemplateColumns = <T extends string>(
  visibleColumns: T[],
  columnWidths: Record<T, string>,
) => {
  return visibleColumns.map((col) => columnWidths[col]).join(' ');
};
